import {useForm} from 'react-hook-form';
import {CrupdateResourceLayout} from '@common/admin/crupdate-resource-layout';
import {Trans} from '@common/i18n/trans';
import {CrupdateChatForm} from './crupdate-chat-form';
import {
  useCreateChat,
} from '../requests/use-create-chat';
import { Chat } from '@app_modules/chats/chat';

interface CreateChatProps {
  callback_url: string;
}

export function CreateChatPage({callback_url}: CreateChatProps) {
  const form = useForm<Chat>({
    defaultValues: {
    },
  });
  const createChat = useCreateChat(form, callback_url);

  return (
    <CrupdateResourceLayout
      form={form}
      onSubmit={values => {
        createChat.mutate(values);
      }}
      title={<Trans message="Create new chat" />}
      isLoading={createChat.isPending}
    >
      <CrupdateChatForm />
    </CrupdateResourceLayout>
  );
}
